import { Card, Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { QueueActions } from "@/pages/App/Driver/DriverQueue/QueueActions";
import { QueueInfo } from "@/pages/App/Driver/DriverQueue/QueueInfo";

export const Route = createFileRoute("/app/fila/")({
  component: DriverQueue,
  head: () => ({
    meta: [{ title: "Fila" }]
  })
});

function DriverQueue() {
  return (
    <Card shadow="md" withBorder className="relative w-full max-w-2xl">
      <Stack>
        <QueueInfo />

        <QueueActions />
      </Stack>
    </Card>
  );
}
